import React from 'react';
import { withStyles } from '@material-ui/core';
import { useWatch } from 'react-hook-form';
import ChargeForSuspensionChx from './components/ChargeForSuspensionChx';
import SuspensionPaymentFrequencyDdl from './components/SuspensionPaymentFrequencyDdl';
import SuspensionFeeTxt from './components/SuspensionFeeTxt';
import styles from './components/styles';

const SuspensionChargeOption = (props) => {
  const { classes, register, control, errors } = props;

  const watchChargeForSuspension = useWatch({
    control,
    name: 'chargeForSuspension',
  });

  return (
    <div className={classes.Container}>
      <ChargeForSuspensionChx classes={classes} register={register} />
      {watchChargeForSuspension ? (
        <>
          <SuspensionFeeTxt
            classes={classes}
            register={register}
            errors={errors}
          />
          <SuspensionPaymentFrequencyDdl classes={classes} control={control} />
        </>
      ) : null}
    </div>
  );
};

export default withStyles(styles)(SuspensionChargeOption);
